import script from "./UserIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UserIcon.vue?vue&type=script&setup=true&lang=js"

import "./UserIcon.vue?vue&type=style&index=0&id=7684db6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7684db6f"]])

export default __exports__